import React from "react";
import QuickCashButtons from "./QuickCashButtons";

export default function QuickCashPanel({ values, onSelect }) {
    return (
        <div className="mb-2">
            <QuickCashButtons values={values} onSelect={onSelect} />
        </div>
    );
}
